import OwnerLanding from './OwnerLanding';

export default OwnerLanding;
